// extracted by mini-css-extract-plugin
module.exports = {"Paper":"AddSelection_Paper__PLD-W","ButtonSubmit":"AddSelection_ButtonSubmit__vCKk7"};